declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown> | unknown[]>;
  }
}

export type AnalyticsParameters = Record<string, unknown>;

const sanitizeAnalyticsParameters = (parameters: AnalyticsParameters) =>
  Object.fromEntries(
    Object.entries(parameters).filter(([, value]) => value !== undefined)
  );

export const trackAnalyticsEvent = (eventName: string, parameters: Record<string, unknown> = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...sanitizeAnalyticsParameters(parameters),
  });
};

export const trackVirtualPageView = (parameters: {
  pagePath: string;
  pageTitle: string;
  route: string;
}) => {
  trackAnalyticsEvent('virtual_page_view', {
    page_path: parameters.pagePath,
    page_title: parameters.pageTitle,
    route: parameters.route,
  });
};

export const trackMarketingCtaClick = (parameters: {
  page: string;
  source: string;
  cta: string;
  destination: string;
}) => {
  trackAnalyticsEvent('marketing_cta_clicked', parameters);
};
